import get from 'lodash/get';

export const getError = (form, attribute) => {
  if (form.submitCount > 0 && get(form.errors, attribute)) {
    return get(form.errors, attribute);
  }
  return null;
};

export const fieldProps = (props, attribute) => {
  const { handleChange, handleBlur, values } = props;
  const value = get(values, attribute);
  const error = getError(props, attribute);
  return {
    handleChange,
    handleBlur,
    value,
    error
  };
};

export const formikFieldProps = (formProps) => {
  return {
    onChange: formProps.setFieldValue,
    onBlur: formProps.setFieldTouched
  };
};

export const setFieldProps = (props, attribute) => {
  const { values } = props;
  const value = get(values, attribute);
  const error = getError(props, attribute);
  return Object.assign(formikFieldProps(props), {
    value,
    error
  });
};

export const processMutationError = (error, actions) => {
  if (error.networkError) {
    console.log(
      'networkError',
      error.networkError.message,
      error.networkError.result
    );
    actions.setStatus({
      networkError: error.networkError
    });
  } else if ('graphqlerrors', error.graphQLErrors) {
    console.log('graphQLErrors', error.graphQLErrors.message);
    actions.setStatus({
      graphQLErrors: error.graphQLErrors
    });
  }
  actions.setSubmitting(false);
};
